import { stringify } from 'qs';

import { serviceApi } from '../service';

export const url = (queryString) =>
  queryString ? `appointment-types?${queryString}` : 'appointment-types';

export const getAppointmentTypes = (queryParams, storeId) =>
  storeId
    ? serviceApi.fetchJSON(`stores/${storeId}/${url(stringify(queryParams))}`)
    : serviceApi.fetchJSON(url(stringify(queryParams)));

export const appointmentTypesApi = {
  getAppointmentTypes,
};
